module.exports = __webpack_public_path__ + "img/cover.2ac1d3cc.jpg";